import { createAsyncThunk } from '@reduxjs/toolkit';
import { ISSUE_TYPES } from '@store/slices/resources';
import { getIssueTypes } from '@services/requests/issueTypes';

export const ThunkGetIssueTypes = createAsyncThunk(
  `${ISSUE_TYPES}/getSurveys`,
  () => getIssueTypes(),
);
